import katex from 'katex'
import Quill from 'quill'
import htmlEditButton from "quill-html-edit-button";
import ImageResize from "quill-image-resize-module--fix-imports-error";
import mathquill4quill from "mathquill4quill";

window.katex = katex;

Quill.register('modules/htmlEditButton', htmlEditButton)
Quill.register('modules/imageResize', ImageResize);

window.Quill = Quill;


export default {
    toolbarOptions: [
        {
            'header': [1, 2, 3, 4, 5, 6, false]
        },
        'bold',
        'italic',
        'underline',
        'strike',
        'link',
        'image',
        { 'list': 'ordered' },
        { 'list': 'bullet' },
        { 'color': [] },
        { 'background': [] },
        'formula'
    ],
    mathOperators: [
        ["\\sqrt[n]{x}", "\\nthroot"], ["\\frac{x}{y}", "\\frac"],
        ["\\exp{x}", "\\superscript"], ["\\_{x}", "\\subscript"],
        ["\\sum^{s}_{x}{d}", "\\sum"], ["\\prod^{s}_{x}{d}", "\\prod"],
        ["\\int^{s}_{x}{d}", "\\int"], ["\\binom{n}{k}", "\\binom"], ["\\cos^{n}", "\\cos"]
    ],
    buildEditor(selector) {
        const targetEl = typeof selector === 'string' ? document.querySelector(selector) : selector;
        if (targetEl) {
            const prevSibling = targetEl.previousElementSibling;
            if (prevSibling && prevSibling.classList.contains('ql-toolbar')) {
                prevSibling.remove();
            }
            const prevEditor = targetEl.querySelector('.ql-editor');
            if (prevEditor) prevEditor.remove();
            const prevClipboard = targetEl.querySelector('.ql-clipboard');
            if (prevClipboard) prevClipboard.remove();
        }

        const placeholder = (targetEl && (targetEl.getAttribute('placeholder') || targetEl.querySelector('textarea, input')?.getAttribute('placeholder'))) || 'Escribe aquí...';

        var editor = new Quill(selector, {
            theme: 'snow',
            placeholder: placeholder,
            bounds: selector,
            modules: {
                formula: true,
                toolbar: this.toolbarOptions,
                htmlEditButton: {
                    debug: false,
                    msg: "Editar el contenido en HTML",
                    okText: "Guardar",
                    cancelText: "Cancelar",
                    buttonHTML: '<svg viewBox="0 0 18 18"><polyline class="ql-even ql-stroke" points="5 7 2 9 5 11"></polyline><polyline class="ql-even ql-stroke" points="13 7 16 9 13 11"></polyline><line class="ql-stroke" x1="10" y1="5" x2="8" y2="13"></line></svg>',
                    buttonTitle: "Mostrar código HTML",
                    syntax: false,
                    prependSelector: 'div#myelement',
                    editorModules: {},
                },
                imageResize: {}
            },
        });

        editor.on('selection-change', (range) => {
            const toolbar = editor.container.previousElementSibling;
            if (range) {
                if (toolbar && toolbar.classList.contains('ql-toolbar')) {
                    toolbar.classList.add('is-focused');
                }
                editor.container.classList.add('is-focused');
            } else {
                if (toolbar && toolbar.classList.contains('ql-toolbar')) {
                    toolbar.classList.remove('is-focused');
                }
                editor.container.classList.remove('is-focused');
            }
        });

        this.bindMathOperators(editor);
        this.bindEmptyStyles(editor);
        return editor;
    },
    bindMathOperators(editor) {
        var enableMathQuillFormulaAuthoring = mathquill4quill();
        enableMathQuillFormulaAuthoring(editor, {
            operators: this.mathOperators,
        });
    },
    bindEmptyStyles(editor) {
        editor.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta){
            var plaintext = node.innerText;
            var Delta = Quill.import('delta');
            return new Delta().insert(plaintext);
          });
    },
}